<template>
  <div
    class="sidebar-tooling"
    data-testid="sidebar-tooling"
  >
    <!-- Search Button -->
    <button
      type="button"
      class="btn btn-sm btn-chiclet mb-2 px-2"
      aria-label="Search"
      title="Search"
      disabled
    >
      <elIcon name="search" :custom-size="18" />
    </button>

    <!-- Help Button -->
    <button
      type="button"
      class="btn btn-sm btn-chiclet mb-2 px-2"
      aria-label="Help"
      title="Help"
      disabled
    >
      <elIcon name="question" :custom-size="18" />
    </button>

    <!-- User Avatar Placeholder -->
    <button
      class="btn btn-sm btn-user mb-2 px-2"
      aria-label="User Menu"
      title="User Menu"
      disabled
    >
      <div class="user-avatar">
        <span class="user-initials">AU</span>
      </div>
    </button>
  </div>
</template>

<script setup>
import elIcon from '@/components/icons/elIcon.vue'
</script>

<style lang="scss" scoped>
.sidebar-tooling {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1001; // Above sidebar content
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px; // $leftNavWidth
  padding: 1rem 0;
  text-align: center;
  background-color: $grey-30;
}

.btn-chiclet {
  padding: 0.25rem;
  color: #c6c9cc; // scale-color($lightTextColor, $lightness: -10%) from original
  background-color: transparent;
  border: none;
  transition: all 0.2s ease;

  // Enforce consistent 18px icon sizing
  :deep(svg) {
    width: 18px !important;
    height: 18px !important;
  }

  &:hover:not(:disabled) {
    color: #dce0e3; // $lightTextColor from original
    background-color: rgba(255, 255, 255, 0.1); // $white10percent
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:active,
  &:focus {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.9) inset; // $black90percent
  }

  &:focus-visible {
    outline: 2px solid #7c82ff; // $accentBlue
    outline-offset: 2px;
  }
}

.btn-user {
  padding: 0.25rem;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.1); // $white10percent from original
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:active,
  &:focus {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.9) inset; // $black90percent
  }

  &:focus-visible {
    outline: 2px solid #7c82ff; // $accentBlue
    outline-offset: 2px;
  }
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #7c82ff 0%, #a78bfa 100%);
  border-radius: 50%;
  overflow: hidden;
}

.user-initials {
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
</style>
